import { Skeleton, useToast } from '@chakra-ui/react';
import React from 'react';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { ExploReportBuilderContainer } from 'packages/explo/ui/ExploReportBuilderContainer';

export const PortfolioOverviewReportBuilderContainer = () => {
  const toast = useToast();

  const { data: userData } = useGetUserQuery({
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
  });

  if (!userData || !userData.user) {
    return <Skeleton h="600px" />;
  }

  return (
    <ExploReportBuilderContainer
      organizationId={userData.user.organizationId}
      exploPlacement="lenderPortfolioTab"
    />
  );
};
